import './mi-tabs-scrollback';
